(function () {
  'use strict';
  if (window.STHCartRecommendations) return;

  var SELECTOR = '[data-sth-cart-recommendations]';
  var SECTION = 'sth-cart-recommendations-data';
  var states = new WeakMap();
  var activeHosts = new Set();
  var cache = new Map();
  var pending = new Map();
  var queue = [];
  var running = 0;
  var nextHost = 0;
  var stopWords = new Set(('a an and the or for with without of to in on by from at as your our new best premium professional original easy adjustable multi purpose multipurpose set pack piece pieces count size large small medium mini oz ounce ounces ml liter litre inch inches cm mm black white red blue green pink grey gray gold silver stainless steel silicone plastic wood bamboo home kitchen product products item items').split(' '));
  var genericTypes = new Set(['general', 'general merchandise', 'default', 'other', 'others', 'misc', 'miscellaneous', 'uncategorized', 'product', 'products', 'item', 'items']);

  function normalized(value) {
    return typeof value === 'string' ? value.normalize('NFKC').trim().toLowerCase() : '';
  }

  function titleKey(value) {
    return normalized(value).replace(/\s+/g, ' ');
  }

  function parse(value, fallback) {
    try { return JSON.parse(value); } catch (_) { return fallback; }
  }

  function read(host, selector, fallback) {
    var element = host.querySelector(selector);
    return element ? parse(element.textContent, fallback) : fallback;
  }

  function imageKey(value) {
    if (!value || typeof value !== 'string') return '';
    try {
      var url = new URL(value, location.origin);
      return /^https?:$/.test(url.protocol) ? url.pathname : '';
    } catch (_) { return ''; }
  }

  function productURL(value) {
    try {
      var url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(url.pathname)) return '';
      return url.pathname;
    } catch (_) { return ''; }
  }

  function product(raw) {
    if (!raw || !/^[1-9]\d*$/.test(String(raw.id)) || !/^[a-z0-9][a-z0-9-]*$/i.test(raw.handle || '') || !titleKey(raw.title)) return null;
    if (!Array.isArray(raw.tags) || raw.tags.some(function (tag) { return typeof tag !== 'string'; })) return null;
    var url = productURL(raw.url || '/products/' + raw.handle);
    if (!url) return null;
    return {
      id: String(raw.id), handle: normalized(raw.handle), title: raw.title,
      titleKey: titleKey(raw.title), type: normalized(raw.type), tags: raw.tags.map(normalized),
      image: imageKey(raw.image), url: url
    };
  }

  function taxonomy(raw) {
    if (!Array.isArray(raw)) return [];
    return raw.filter(function (row) {
      return row && /^[a-z0-9][a-z0-9-]*$/.test(row.handle || '') && typeof row.label === 'string' && Array.isArray(row.rules);
    }).map(function (row) {
      return {
        handle: row.handle, label: row.label,
        rules: row.rules.filter(function (rule) {
          return rule && (rule.field === 'product_type' || rule.field === 'tag') && typeof rule.value === 'string';
        }).map(function (rule) { return { field: rule.field, value: normalized(rule.value) }; })
      };
    });
  }

  function describe(item, departments, broadTypes) {
    // Collection TYPE rules have priority over every TAG rule, as in browsing history.
    item.department = departments.find(function (row) {
      return row.rules.some(function (rule) { return rule.field === 'product_type' && rule.value === item.type; });
    }) || departments.find(function (row) {
      return row.rules.some(function (rule) { return rule.field === 'tag' && item.tags.includes(rule.value); });
    }) || null;
    var prefixes = item.department ? item.department.rules.filter(function (rule) {
      return rule.field === 'tag' && rule.value.startsWith('dept:');
    }).map(function (rule) { return 'sub:' + rule.value.slice(5) + '--'; }) : [];
    item.subcategories = item.tags.filter(function (tag) {
      return prefixes.some(function (prefix) { return tag.startsWith(prefix) && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(tag.slice(prefix.length)); });
    }).sort();
    item.narrowType = item.type && !broadTypes.has(item.type) && !genericTypes.has(item.type) ? item.type : '';
    item.terms = new Set((item.titleKey.match(/[\p{L}]+/gu) || []).filter(function (term) {
      return term.length >= 3 && !stopWords.has(term);
    }));
    return item;
  }

  function relevance(seed, candidate, intent) {
    var sameType = seed.narrowType && seed.narrowType === candidate.narrowType;
    if (!seed.department || !candidate.department) {
      return !seed.department && !candidate.department && sameType ? 90 : 0;
    }
    if (seed.department.handle !== candidate.department.handle) return 0;
    var sharedSub = seed.subcategories.some(function (sub) { return candidate.subcategories.includes(sub); });
    var overlap = Array.from(seed.terms).filter(function (term) { return candidate.terms.has(term); }).length;
    if (intent !== 'complementary' && seed.subcategories.length && candidate.subcategories.length && !sharedSub) return 0;
    if (sharedSub) return 100 + Math.min(overlap, 10);
    if (sameType) return 90;
    if (intent === 'complementary') return 70;
    return overlap >= 2 ? 60 + Math.min(overlap, 10) : 0;
  }

  function rootPath(value) {
    try {
      var url = new URL(value || '/', location.origin);
      if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/?)?$/i.test(url.pathname)) return '/';
      return url.pathname.replace(/\/?$/, '/');
    } catch (_) { return '/'; }
  }

  function recommendationURL(value, root) {
    try {
      var url = new URL(value || root + 'recommendations/products', location.origin);
      if (url.origin !== location.origin || url.pathname !== root + 'recommendations/products') return null;
      url.search = '';
      url.hash = '';
      return url;
    } catch (_) { return null; }
  }

  function live(state) {
    var seeds = state.host.querySelector('[data-sth-cart-seeds]');
    return !state.cancelled && state.host.isConnected && states.get(state.host) === state && (seeds ? seeds.textContent : '') === state.seedText;
  }

  function cachePut(key, text) {
    cache.delete(key);
    cache.set(key, { text: text, expires: Date.now() + 45000 });
    while (cache.size > 40) cache.delete(cache.keys().next().value);
  }

  function pump() {
    while (running < 3 && queue.length) {
      var entry = queue.shift();
      if (entry.controller.signal.aborted || !entry.clients.size) {
        entry.reject(new Error('Recommendation request cancelled'));
        if (pending.get(entry.url) === entry) pending.delete(entry.url);
        continue;
      }
      run(entry);
    }
  }

  async function run(entry) {
    running += 1;
    var timer;
    try {
      var aborted = new Promise(function (_, reject) {
        entry.controller.signal.addEventListener('abort', function () { reject(new Error('Recommendation request cancelled')); }, { once: true });
      });
      timer = setTimeout(function () { entry.controller.abort(); }, 8000);
      var response = await Promise.race([
        fetch(entry.url, { credentials: 'same-origin', signal: entry.controller.signal, headers: { Accept: 'text/html' } }).then(function (result) {
          if (!result.ok) throw new Error('Recommendation request failed');
          return result.text();
        }), aborted
      ]);
      if (entry.controller.signal.aborted) throw new Error('Recommendation request cancelled');
      cachePut(entry.url, response);
      entry.resolve(response);
    } catch (error) {
      entry.reject(error);
    } finally {
      clearTimeout(timer);
      if (pending.get(entry.url) === entry) pending.delete(entry.url);
      entry.clients.forEach(function (state) { state.requests.delete(entry); });
      running -= 1;
      pump();
    }
  }

  function request(state, url) {
    var key = url.href;
    var hit = cache.get(key);
    if (hit && hit.expires > Date.now()) {
      cache.delete(key);
      cache.set(key, hit);
      return Promise.resolve(hit.text);
    }
    cache.delete(key);
    var entry = pending.get(key);
    if (!entry || entry.controller.signal.aborted) {
      entry = { url: key, clients: new Set(), controller: new AbortController() };
      entry.promise = new Promise(function (resolve, reject) { entry.resolve = resolve; entry.reject = reject; });
      pending.set(key, entry);
      queue.push(entry);
    }
    entry.clients.add(state);
    state.requests.add(entry);
    pump();
    return entry.promise;
  }

  function candidates(text, state) {
    var doc = new DOMParser().parseFromString(text, 'text/html');
    return Array.from(doc.querySelectorAll('template[data-sth-cart-candidate]')).map(function (template) {
      var data = template.dataset;
      if (data.available !== 'true' || data.requiresPlan !== 'false') return null;
      var item = product({ id: data.productId, handle: data.handle, title: data.title, type: data.type, tags: parse(data.tags, null), image: data.image, url: data.url });
      var card = template.content.firstElementChild;
      if (!item || !card || card.tagName !== 'LI') return null;
      item.card = card;
      return describe(item, state.departments, state.broadTypes);
    }).filter(Boolean);
  }

  function exclusion() {
    return { ids: new Set(), handles: new Set(), titles: new Set(), images: new Set() };
  }

  function remember(set, item) {
    set.ids.add(item.id);
    set.handles.add(item.handle);
    set.titles.add(item.titleKey);
    if (item.image) set.images.add(item.image);
  }

  function duplicate(set, item) {
    return set.ids.has(item.id) || set.handles.has(item.handle) || set.titles.has(item.titleKey) || (item.image && set.images.has(item.image));
  }

  function choose(state) {
    var seen = exclusion();
    state.seeds.forEach(function (seed) { remember(seen, seed); });
    var rows = state.groups.map(function (group) {
      return group.candidates.slice().sort(function (a, b) { return b.score - a.score || a.order - b.order; });
    });
    var selected = [];
    var progressed = true;
    while (selected.length < state.limit && progressed) {
      progressed = false;
      rows.forEach(function (row) {
        if (selected.length >= state.limit) return;
        while (row.length) {
          var candidate = row.shift().item;
          if (duplicate(seen, candidate)) continue;
          remember(seen, candidate);
          selected.push(candidate);
          progressed = true;
          break;
        }
      });
    }
    return selected;
  }

  function namespace(card, prefix) {
    var mappings = new Map();
    var elements = [card].concat(Array.from(card.querySelectorAll('*')));
    var idIndex = 0;
    elements.forEach(function (node) {
      // Shopify's input[name="id"] shadows HTMLFormElement.id.
      var old = node.getAttribute('id');
      if (!old) return;
      var next = prefix + '-' + (++idIndex);
      node.setAttribute('id', next);
      if (!mappings.has(old)) mappings.set(old, next);
    });
    elements.forEach(function (node) {
      ['for', 'form', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'aria-owns', 'list'].forEach(function (attribute) {
        if (!node.hasAttribute(attribute)) return;
        node.setAttribute(attribute, node.getAttribute(attribute).split(/\s+/).map(function (id) { return mappings.get(id) || id; }).join(' '));
      });
      var href = node.getAttribute('href');
      if (href && href.charAt(0) === '#' && mappings.has(href.slice(1))) node.setAttribute('href', '#' + mappings.get(href.slice(1)));
    });
    return card;
  }

  function initializeNative() {
    ['listScrollable', 'listCollectionSlider', 'formZindex', 'semanticInput', 'ratings', 'schemeTooltip', 'popups', 'semanticSelect', 'productcardVariants', 'check-limit-event'].forEach(function (name) {
      try { window.dispatchEvent(new CustomEvent(name)); } catch (_) { /* An optional theme feature cannot prevent the cart from working. */ }
    });
    ['ajaxCart', 'quickShop'].forEach(function (name) {
      try { if (window[name] && typeof window[name].init === 'function') window[name].init(); } catch (_) { /* Leave the product link usable. */ }
    });
  }

  function render(state, selected) {
    if (!live(state)) return;
    var list = state.host.querySelector('[data-sth-cart-recommendations-list]');
    var status = state.host.querySelector('[data-sth-cart-recommendations-status]');
    var links = state.host.querySelector('[data-sth-cart-recommendations-links]');
    if (!list) return;
    var fragment = document.createDocumentFragment();
    selected.forEach(function (item, index) {
      fragment.appendChild(namespace(document.importNode(item.card, true), state.prefix + '-' + index));
    });
    list.replaceChildren(fragment);
    list.hidden = !selected.length;
    var departments = [];
    state.seeds.forEach(function (seed) {
      if (seed.department && !departments.some(function (row) { return row.handle === seed.department.handle; })) departments.push(seed.department);
    });
    if (links) {
      links.replaceChildren();
      if (!selected.length) departments.slice(0, 4).forEach(function (row) {
        var link = document.createElement('a');
        link.href = state.root + 'collections/' + encodeURIComponent(row.handle);
        link.textContent = row.label;
        links.appendChild(link);
      });
      links.hidden = !links.children.length;
    }
    if (status) {
      status.textContent = !selected.length && departments.length ? 'Explore more from these departments' : '';
      status.hidden = !status.textContent;
    }
    state.host.hidden = !selected.length && !(links && links.children.length);
    state.host.dataset.sthRecommendationsLoading = 'false';
    state.host.dataset.sthRecommendationsReady = 'true';
    if (selected.length) initializeNative();
  }

  async function fill(state) {
    var jobs = [];
    if (state.recommendations) state.groups.forEach(function (group) {
      state.intents.forEach(function (intent) {
        var url = new URL(state.recommendations.href);
        url.searchParams.set('product_id', group.seed.id);
        url.searchParams.set('limit', '10');
        url.searchParams.set('intent', intent);
        url.searchParams.set('section_id', SECTION);
        jobs.push({ group: group, intent: intent, promise: request(state, url) });
      });
    });
    var responses = await Promise.allSettled(jobs.map(function (job) { return job.promise; }));
    if (!live(state)) return;
    responses.forEach(function (response, index) {
      if (response.status !== 'fulfilled') return;
      var job = jobs[index];
      candidates(response.value, state).forEach(function (item) {
        var score = relevance(job.group.seed, item, job.intent);
        if (score) job.group.candidates.push({ item: item, score: score, order: job.group.candidates.length });
      });
    });
    var selected = choose(state);
    if (selected.length < state.limit) {
      var fallback = state.groups.filter(function (group) { return group.seed.subcategories.length || group.seed.narrowType; });
      var searches = await Promise.allSettled(fallback.map(function (group) {
        var url = new URL(state.root + 'search', location.origin);
        var query = group.seed.subcategories.length ? 'tag:"' + group.seed.subcategories[0] + '"' : 'product_type:"' + group.seed.narrowType.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
        url.searchParams.set('type', 'product');
        url.searchParams.set('q', query);
        url.searchParams.set('section_id', SECTION);
        return request(state, url);
      }));
      if (!live(state)) return;
      searches.forEach(function (response, index) {
        if (response.status !== 'fulfilled') return;
        var group = fallback[index];
        candidates(response.value, state).forEach(function (item) {
          var score = relevance(group.seed, item, 'related');
          if (score) group.candidates.push({ item: item, score: score, order: group.candidates.length });
        });
      });
      selected = choose(state);
    }
    render(state, selected);
  }

  function init(host) {
    if (!host || states.has(host)) return;
    var departments = taxonomy(read(host, '[data-sth-cart-departments]', []));
    var broadTypes = new Set();
    departments.forEach(function (row) { row.rules.forEach(function (rule) { if (rule.field === 'product_type') broadTypes.add(rule.value); }); });
    var raw = read(host, '[data-sth-cart-seeds]', []);
    var seeds = Array.isArray(raw) ? raw.map(product).filter(Boolean).map(function (item) { return describe(item, departments, broadTypes); }) : [];
    var intentValue = host.dataset.intents;
    var intents = parse(intentValue, null);
    if (!Array.isArray(intents)) intents = typeof intentValue === 'string' ? intentValue.split(',') : ['related'];
    intents = Array.from(new Set(intents.map(normalized).filter(function (intent) { return intent === 'related' || intent === 'complementary'; })));
    var root = rootPath(host.dataset.rootUrl);
    var state = {
      host: host, departments: departments, broadTypes: broadTypes, seeds: seeds, groups: [],
      seedText: host.querySelector('[data-sth-cart-seeds]') ? host.querySelector('[data-sth-cart-seeds]').textContent : '',
      limit: Math.max(1, Math.min(10, Math.floor(Number(host.dataset.limit) || 4))),
      intents: intents, root: root, recommendations: recommendationURL(host.dataset.recommendationsUrl, root),
      requests: new Set(), cancelled: false, prefix: 'sth-cart-rec-' + (++nextHost)
    };
    var groupKeys = new Set();
    seeds.forEach(function (seed) {
      if (state.groups.length >= 4) return;
      var key = seed.subcategories[0] || (seed.narrowType ? (seed.department ? seed.department.handle : 'unknown') + ':type:' + seed.narrowType : seed.department && 'dept:' + seed.department.handle);
      if (!key || groupKeys.has(key)) return;
      groupKeys.add(key);
      state.groups.push({ seed: seed, candidates: [] });
    });
    states.set(host, state);
    activeHosts.add(state);
    host.hidden = true;
    var list = host.querySelector('[data-sth-cart-recommendations-list]');
    if (list) list.replaceChildren();
    host.dataset.sthRecommendationsReady = 'false';
    host.dataset.sthRecommendationsLoading = 'true';
    if (!intents.length || !seeds.length) render(state, []);
    else fill(state).catch(function () { render(state, []); });
  }

  function scan(node) {
    if (!node || (node.nodeType !== 1 && node.nodeType !== 9)) return;
    if (node.matches && node.matches(SELECTOR)) init(node);
    node.querySelectorAll(SELECTOR).forEach(init);
  }

  function prune() {
    activeHosts.forEach(function (state) {
      if (live(state)) return;
      state.cancelled = true;
      state.requests.forEach(function (entry) {
        entry.clients.delete(state);
        if (!entry.clients.size) entry.controller.abort();
      });
      state.requests.clear();
      activeHosts.delete(state);
      states.delete(state.host);
      if (state.host.isConnected) init(state.host);
    });
  }

  function boot() {
    scan(document);
    new MutationObserver(function (records) {
      prune();
      records.forEach(function (record) { record.addedNodes.forEach(scan); });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
    document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  }

  window.STHCartRecommendations = { init: scan };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());
